export const roles = {
    admin: 'admin',
    director: 'director',
    manager: 'manager',
    accountant: 'accountant',
    dentist: 'dentist',
    assistent: 'assistent',
    hygienist: 'hygienist'
};